import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import PrimaryButton from "../../../../ui/components/PrimaryButton";

interface Props extends WithTranslation {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const SubmitToBenchmarkPopup: React.FC<Props> = ({
  t,
  open,
  onCancel,
  onConfirm,
  isSubmitting,
}) => {
  const title = t("proCheck.submitToBenchmarkTitle");
  const message = t("proCheck.submitToBenchmarkMessage");
  const cancelLabel = t("proCheck.submitToBenchmarkCancel");
  const continueLabel = t("proCheck.submitToBenchmarkContinue");

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <Box minWidth={520}>
        <DialogTitle disableTypography>
          <Typography variant="h2" align="left" color="primary">
            <strong>{title}</strong>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            {message}
          </Typography>
        </DialogContent>
        <DialogActions style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 16, paddingRight: 32 }}>
          <Box display="flex" alignItems="center" width="100%" justifyContent="flex-end">
            <Box marginRight={2}>
              <PrimaryButton
                variant="text"
                colour="secondary"
                label={cancelLabel}
                onClick={onCancel}
                isLoading={isSubmitting}
              />
            </Box>
            <PrimaryButton
              variant="text"
              colour="primary"
              label={continueLabel}
              onClick={onConfirm}
              isLoading={isSubmitting}
            />
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default withTranslation()(SubmitToBenchmarkPopup);